import React from 'react';
import "./BlogPost.css";

import arc1 from '../../Assets/b65/arc1.jpg';
import arc2 from '../../Assets/b65/arc2.jpg';
import arc3 from '../../Assets/b65/arc3.jpg';
import arc4 from '../../Assets/b65/arc4.jpg';
import arc5 from '../../Assets/b65/arc5.jpg';
import arc6 from '../../Assets/b65/arc6.jpg';
import arc7 from '../../Assets/b65/arc7.jpg';
import arc8 from '../../Assets/b65/arc8.jpg';
import arc9 from '../../Assets/b65/arc9.jpg';
import arc10 from '../../Assets/b65/arc10.jpg';

function Blog65(){
  return (
    <>
      <div className='container-fluid my-5'>
        <div className='row mb-5'>
          <div className='col blog-text text-center'>
            <h1>Let’s hit our targets this year one shot at a time 🏹🎯</h1>
            <h6>February 08, 2026 at 06:00 PM</h6>
          </div>
        </div>

        <div className='row align-items-center justify-content-center mx-5 gx-5 gy-5'>
          <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-5 col-xxl-5'>
            <div id="blogImages" className="carousel slide mx-auto" data-bs-ride="true" data-bs-interval='3000'>
              <div className="carousel-indicators">
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="1" aria-label="Slide 2"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="2" aria-label="Slide 3"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="3" aria-label="Slide 4"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="4" aria-label="Slide 5"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="5" aria-label="Slide 6"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="6" aria-label="Slide 7"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="7" aria-label="Slide 8"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="8" aria-label="Slide 9"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="9" aria-label="Slide 10"></button>
              </div>
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <img src={arc1} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={arc2} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={arc3} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={arc4} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={arc5} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={arc6} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={arc7} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={arc8} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={arc9} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={arc10} className="blog-img" alt="..."/>
                </div>
              </div>
              <button className="carousel-control-prev" type="button" data-bs-target="#blogImages" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
              </button>
              <button className="carousel-control-next" type="button" data-bs-target="#blogImages" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
          <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 blog-text'>
            <p>With our theme centered on hitting the right targets, we put our focus and precision to the test through archery — a perfect reminder that achieving goals requires clarity, alignment, and steady hands. </p>
            <p>After aiming high and giving our best shots, we wrapped up the day with a dinner together because food is more delicious when shared 💙</p>
            <p><a href='https://www.facebook.com/hashtag/mytsoftdevsolutions' target='_blank' className='blog-link'>
              #MYTSoftDevSolutions</a>
              <a href='https://www.facebook.com/hashtag/buildtolast' target='_blank' className='blog-link'>
              #BuildToLast</a>
              <a href='https://www.facebook.com/hashtag/techforgood' target='_blank' className='blog-link'>
              #TechForGood</a>
              <a href='https://www.facebook.com/hashtag/markyourtargets' target='_blank' className='blog-link'>
              #MarkYourTargets </a>
              <a href='https://www.facebook.com/hashtag/masteryourtime' target='_blank' className='blog-link'>
              #MasterYourTime</a>
              <a href='https://www.facebook.com/hashtag/masteryourtask' target='_blank' className='blog-link'>
              #MasterYourTask</a></p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Blog65;